var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70614 0.66748C8.85608 0.66748 8.96854 0.742453 9.04351 0.892398C9.11849 1.04234 9.081 1.19229 8.96854 1.30475L5.21992 5.05337C5.06998 5.20331 4.84506 5.20331 4.69512 5.05337L0.946497 1.30475C0.834038 1.19229 0.796552 1.04234 0.871525 0.892398C0.909011 0.742453 1.05896 0.66748 1.2089 0.66748L8.70614 0.66748Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.2c6d160793eb29b5ed72222308b24ee6.svg";
export { ForwardRef as ReactComponent };